"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const apollo_link_1 = require("apollo-link");
const apollo_link_http_1 = require("apollo-link-http");
const apollo_upload_client_1 = require("apollo-upload-client");
exports.JUDO_SESSION_KEY = 'judo_session';
const environments = {
    production: 'https://api.rover.io/graphql',
    staging: 'https://api.staging.rover.io/graphql',
};
const uri = environments[process.env.NODE_ENV] || 'http://localhost:4000/graphql';
exports.isRunningInIframe = () => {
    return window !== window.parent;
};
exports.getJudoTokenFromURL = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('token');
};
exports.getToken = () => {
    const session = JSON.parse(localStorage.getItem('ember_simple_auth:session'));
    return session ? session.authenticated.token : null;
};
exports.getJudoToken = () => {
    const session = JSON.parse(sessionStorage.getItem(exports.JUDO_SESSION_KEY));
    return session ? session.token : exports.getJudoTokenFromURL();
};
exports.generateHeaders = () => {
    const token = exports.getToken();
    const judoToken = exports.getJudoToken();
    const headers = {
        accept: 'application/json',
    };
    if (judoToken) {
        return Object.assign(Object.assign({}, headers), { 'x-judo-token-key': judoToken });
    }
    else if (token) {
        return Object.assign(Object.assign({}, headers), { Authorization: `Bearer ${token}` });
    }
    return headers;
};
const httpLink = new apollo_link_http_1.HttpLink({
    headers: exports.generateHeaders(),
    uri,
});
const link = apollo_link_1.ApolloLink.split((operation) => operation.operationName !== 'DeviceListUpload', httpLink, apollo_upload_client_1.createUploadLink({
    headers: exports.generateHeaders(),
    uri,
}));
exports.default = (operation) => {
    return apollo_link_1.makePromise(apollo_link_1.execute(link, operation));
};
